import { B as BUILD, C as CSS, p as plt, w as win, a as promiseResolve, b as bootstrapLazy } from './index-81f410e5.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';

/*
 Stencil Client Patch Esm v2.18.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    // NOTE!! This fn cannot use async/await!
    // @ts-ignore
    if (BUILD.cssVarShim && !(CSS && CSS.supports && CSS.supports('color', 'var(--c)'))) {
        // @ts-ignore
        return import(/* webpackChunkName: "polyfills-css-shim" */ './css-shim-b3f2ee8d.js').then(() => {
            if ((plt.$cssShim$ = win.__cssshim)) {
                return plt.$cssShim$.i();
            }
            else {
                // for better minification
                return 0;
            }
        });
    }
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  globalScripts();
  return bootstrapLazy([["ispui-tooltip",[[4,"ispui-tooltip",{"width":[1],"preset":[513],"tooltipClass":[513,"tooltip-class"],"attachNode":[16],"viewportNode":[16],"attachSelector":[513,"attach-selector"],"viewportSelector":[513,"viewport-selector"],"scrollSelector":[513,"scroll-selector"],"titleText":[513,"title-text"],"asHtml":[516,"as-html"],"placement":[513],"placementOrder":[16],"animation":[516],"offsets":[16],"mouseEnterDelay":[514,"mouse-enter-delay"],"mouseLeaveDelay":[514,"mouse-leave-delay"],"ellipsis":[516],"disabled":[516],"tooltipWidth":[513,"tooltip-width"],"disabledArrow":[516,"disabled-arrow"],"followCursor":[516,"follow-cursor"],"visible":[32],"toggle":[64]},[[1,"mouseover","mouseOverTooltipHandler"],[1,"mouseout","mouseOutTooltipHandler"]]]]],["ispui-tooltip-wrapper",[[4,"ispui-tooltip-wrapper",{"tooltipSelectorPrefix":[1,"tooltip-selector-prefix"],"globalDebounce":[2,"global-debounce"]}]]],["ispui-tooltip-popup",[[4,"ispui-tooltip-popup",{"context":[16],"visible":[4],"content":[32],"hide":[64]}]]]], options);
  });
};

export { defineCustomElements };
